/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentAccountSimpleDto } from './paymentAccountSimpleDto';
import { InvoiceItemSimpleDto } from './invoiceItemSimpleDto';
import { TransactionSimpleDto } from './transactionSimpleDto';


export interface InvoiceDto { 
    id?: number;
    insertTs?: string;
    amountRequested?: number;
    amountPaid?: number;
    currency?: InvoiceDto.CurrencyEnum;
    invoiceDate?: string;
    paid?: boolean;
    fakturaInvoiceId?: string;
    creditCardFee?: number;
    vatRate?: number;
    porto?: number;
    invoiceItems?: Array<InvoiceItemSimpleDto>;
    transactions?: Array<TransactionSimpleDto>;
    paymentAccount?: PaymentAccountSimpleDto;
}
export namespace InvoiceDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


